

















































import Vue from "vue";
import Component from "vue-class-component";
import TLogin from "@/components/template/Login.vue";
import Textbox from "@/components/atoms/Textbox.vue";
import AlertMessage from "@/components/atoms/AlertMessage.vue";
import { IAlertInfo } from "@/types";
import * as CONSTANTS from "../common/constants";
import { Auth } from "aws-amplify";
import { OperationLogsStore } from "@/store";
import { OperationLogs } from "@/store/modules/operationLogs";
import Utils from "@/common/utils";

@Component({
  components: { TLogin, Textbox, AlertMessage },
})
export default class Login extends Vue {
  name: "Login";
  private userId = "";
  private password = "";
  private dangerAlertList: IAlertInfo[] = [];

  private async onClickLoginButton(): Promise<void> {
    try {
      Utils.showTransparentLoadingModal(this.$bvModal);
      this.clearAlertList();

      await Auth.signIn(this.userId, this.password);
      await OperationLogsStore.recordOperationLogsNonAuth({
        email: this.userId,
        operation_class: OperationLogs.OPERATION_CLASS.LOGIN,
      });
      this.$router.push({
        name: CONSTANTS.ROUTE_NAME.EMPLOYEES_LIST,
      });
    } catch (e: any) {
      console.error(e);
      if (e && Array.isArray(e)) {
        e.forEach((error: any) => {
          if (error.item && error.message) {
            this.dangerAlertList.push({
              item: error.item,
              message: error.message,
            });
          }
        });
        return;
      } else if (e && e.message) {
        console.error(e.message);
        let mes = Utils.getErrorMessageByErrorCodeWithoutDefaultError(
          String(e.message)
        );
        if (mes) {
          this.dangerAlertList.push({
            item: "AMPLIFY",
            message: mes,
          });
          return;
        }
      }
      this.dangerAlertList.push({
        item: "AMPLIFY",
        message: Utils.getErrorMessageByErrorCode("EI001"),
      });
    } finally {
      this.password = "";
      Utils.hideTransparentLoadingModal(this.$bvModal);
    }
  }

  private onClickForgotPasswordLink(): void {
    this.$router.push({
      name: CONSTANTS.ROUTE_NAME.PASSWORD_RESET,
    });
  }

  private onKeyDownEnter(): void {
    this.onClickLoginButton();
  }

  private clearAlertList(): void {
    this.dangerAlertList = [];
  }
}
